import * as Yup from 'yup';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useState, useEffect } from 'react';
// @mui
import { LoadingButton } from '@mui/lab';
import { Box, Typography, Stack } from '@mui/material';
// eslint-disable-next-line import/no-extraneous-dependencies
import moment from 'moment';
// components
import Notification from '../../components/Notification/Notification';
import FormProvider, { RHFTextField, RHFSelect, RHFDatePicker } from '../../components/hook-form';
import { useAuthContext } from '../../auth/useAuthContext';
import { updateUserProfile, clearUserProfileAction } from '../../redux/slices/profile';
import { useDispatch, useSelector } from '../../redux/store';
import useResponsive from '../../hooks/useResponsive';
//
import AccountLayout from '.';

// ----------------------------------------------------------------------

const d = new Date();
const year = d.getFullYear();
const GENDER_OPTIONS = ['Male', 'Female', 'Other'];
const YEAR_OPTIONS = [year, year + 1];

// ----------------------------------------------------------------------

AccountPersonalView.propTypes = {
  currentUserProfile: PropTypes.object,
};

export default function AccountPersonalView({ currentUserProfile }) {
  const dispatch = useDispatch();
  const isMdUp = useResponsive('up', 'md');
  const { userProfile, userProfileAction } = useSelector((state) => state.profile);
  const { user } = useAuthContext();
  const [UserProfileData, setUserProfileData] = useState(currentUserProfile);
  const [notification, setNotification] = useState({
    open: false,
    msg: "",
    type: "success",
  });

  const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/

  const AccountPersonalSchema = Yup.object().shape({
    firstName: Yup.string().required('First name is required'),
    lastName: Yup.string().required('Last name is required'),
    emailAddress: Yup.string().required('Email address is required').email('Email address must be a valid email address'),
    phoneNumber: Yup.string('Phone number is required').matches(phoneRegExp, 'Phone number must be a valid number').min(10, "Phone number must be a valid number").max(11, "Phone number must be a valid number"),
    birthday: Yup.string().required('Date of Birth is required'),
    gender: Yup.string().required('Gender is required'),
    year: Yup.string().required('Year intake is required'),
  });

  const defaultValues = {
    firstName: UserProfileData?.FirstName || "",
    lastName: UserProfileData?.LastName || "",
    emailAddress: UserProfileData?.UserEmailAddress || "",
    phoneNumber: UserProfileData?.UserContactNo || "",
    birthday: UserProfileData && UserProfileData.UserDOB ? new Date(UserProfileData.UserDOB) : new Date(),
    gender: UserProfileData?.UserGender || "",
    year: UserProfileData?.YearIntake || year,
  };

  const methods = useForm({
    resolver: yupResolver(AccountPersonalSchema),
    defaultValues,
  });

  const {
    handleSubmit,
    formState: { isSubmitting, errors, dirtyFields },
  } = methods;

  const onSubmit = async (data) => {
    try {
      await new Promise((resolve) => setTimeout(resolve, 500));
      if (dirtyFields.birthday || dirtyFields.firstName || dirtyFields.lastName || dirtyFields.phoneNumber || dirtyFields.gender || dirtyFields.emailAddress || dirtyFields.year) {
        dispatch(updateUserProfile(UserProfileData?.UserID ? UserProfileData?.UserID : user.UserID, data.firstName, data.lastName, data.phoneNumber, moment(data.birthday).format('YYYYMMDD'), data.emailAddress, data.gender, data.year))
        console.log("2", UserProfileData)
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    console.log("ww", userProfileAction)
    if (userProfileAction) {
      setNotification({
        open: true,
        msg: "Profile Updated Successfully",
        type: "success",
      })
      setUserProfileData(userProfileAction)
      console.log("1", userProfileAction)
      dispatch(clearUserProfileAction());
      // dispatch(getUserProfile('UserProfile', user?.UserID, 0, 999, 1, user?.UserID))
    }
  }, [dispatch, userProfileAction]);

  return (
    <>
      <Helmet>
        <title>Profile | MAGScholar </title>
      </Helmet>

      <AccountLayout>
        <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
          {isMdUp &&
            <Stack direction="row" justifyContent="space-between">
              <Typography variant="h5" sx={{ mb: 3 }}>
                Personal
              </Typography>

            </Stack>
          }
          {console.log(UserProfileData)}
          {!UserProfileData?.FirstName || !UserProfileData?.LastName || !UserProfileData?.YearIntake ? <Typography sx={{ mb: 3, color: "red", fontSize: "12px" }}>
            *Please fill in first name, last name and year of intake
          </Typography> : <></>}
          <Box
            rowGap={2.5}
            columnGap={2}
            mb={3}
            display="grid"
            gridTemplateColumns={{ xs: 'repeat(1, 1fr)', md: 'repeat(2, 1fr)' }}
          >
            <RHFTextField name="firstName" label="First Name" />

            <RHFTextField name="lastName" label="Last Name" />

            <RHFTextField name="emailAddress" label="Email Address" />

            <RHFTextField name="phoneNumber" label="Phone Number" />

            <RHFDatePicker name="birthday" label="Birthday" />
            <RHFSelect native name="gender" label="Gender">
              {GENDER_OPTIONS.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </RHFSelect>
            <RHFSelect native name="year" label="Year of Intake">
              {YEAR_OPTIONS.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </RHFSelect>
          </Box>

          <LoadingButton
            size="medium"
            type='submit'
            variant="contained"
            loading={isSubmitting}
          >
            Save Changes
          </LoadingButton>
        </FormProvider>

        <Notification notification={notification} setNotification={setNotification} />
      </AccountLayout>
    </>
  );
}
